import {
  ZODIAC_SIGNS,
  getSignHoroscope,
  STORAGE_SIGN_KEY,
  STORAGE_SIGN_KEY_LEGACY,
  type ZodiacId,
} from '../data/astrology';

/**
 * Renders the horoscope (your sign today) panel into the given container.
 */
export function renderHoroscopeCard(container: HTMLElement): void {
  const now = new Date();
  let stored =
    (typeof localStorage !== 'undefined' &&
      localStorage.getItem(STORAGE_SIGN_KEY)) ||
    '';
  if (!stored && typeof localStorage !== 'undefined') {
    const legacy = localStorage.getItem(STORAGE_SIGN_KEY_LEGACY);
    if (legacy && ZODIAC_SIGNS.some((z) => z.id === legacy)) {
      stored = legacy;
      try {
        localStorage.setItem(STORAGE_SIGN_KEY, legacy);
      } catch {
        /* ignore */
      }
    }
  }
  const initial: ZodiacId = ZODIAC_SIGNS.some((z) => z.id === stored)
    ? (stored as ZodiacId)
    : 'gemini';

  const panel = document.createElement('div');
  panel.className = 'panel';
  panel.innerHTML = `
    <div class="panel-title">✨ Your sign today</div>
    <div class="sign-row">
      <label for="zodiac-select">Sun sign</label>
      <select id="zodiac-select" class="sign-select" aria-label="Choose zodiac sign">
        ${ZODIAC_SIGNS.map(
          (z) =>
            `<option value="${z.id}" ${z.id === initial ? 'selected' : ''}>${z.symbol} ${z.name} · ${z.dates}</option>`
        ).join('')}
      </select>
    </div>
    <ul class="horoscope-lines" id="horoscope-lines"></ul>
  `;
  container.appendChild(panel);

  const select = panel.querySelector('#zodiac-select') as HTMLSelectElement;
  const list = panel.querySelector('#horoscope-lines') as HTMLUListElement;

  function refreshLines(sign: ZodiacId): void {
    const lines = getSignHoroscope(sign, now);
    list.innerHTML = lines.map((l) => `<li>${l}</li>`).join('');
  }

  refreshLines(initial);
  select.addEventListener('change', () => {
    const sign = select.value as ZodiacId;
    try {
      localStorage.setItem(STORAGE_SIGN_KEY, sign);
    } catch {
      /* ignore */
    }
    refreshLines(sign);
  });
}
